import {
  FETCH_CLUSTER_DATA_START,
  FETCH_CLUSTER_DATA_SUCCESS,
  FETCH_CLUSTER_DATA_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  clusterData: [],
  isFetching: true,
  errorMessage: '',
}

const clusterDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CLUSTER_DATA_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_CLUSTER_DATA_SUCCESS:
      return {
        ...state,
        clusterData: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_CLUSTER_DATA_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default clusterDataReducer
